export default function () {
	const questions = [
		{
			question: "What's your interior style?",
			background: '#50606E',
			theme: 'light',
			required_answers_count: 1,
			answers: [
				{
					category: 'Bold',
					heading: 'Make a Statement',
					text: 'Bold colour combos and playful patterns for a unique design that radiates joy and individuality.'
				},
				{
					category: 'Classic',
					heading: 'Classic Charm',
					text: 'Where timeless elegance meets comfort for a luxurious and traditional feel.'
				},
				{
					category: 'Minimalist',
					heading: 'Minimalist',
					text: 'Soft neutral shades in an uncluttered and organised space, where everything has a home.'
				},
				{
					category: 'Calming',
					heading: 'A Serene Oasis',
					text: 'A calming blend of nature-inspired hues and textures, in a light and refreshing space for the ultimate zen.'
				},
				{
					category: 'Romantic',
					heading: 'Elegant Haven',
					text: 'Graceful and charming, a romantic allure with delicate details and soft pastel hues.'
				}
			],
			expectedSrcs: ['']
		},
		{
			question: 'Describe yourself in 2 words',
			background: '#DED4CD',
			theme: 'dark',
			required_answers_count: 2,
			answers: [
				{ category: 'Bold', heading: 'Creative' },
				{ category: 'Classic', heading: 'Sophisticated' },
				{ category: 'Minimalist', heading: 'Minimalist' },
				{ category: 'Calming', heading: 'Grounded' },
				{ category: 'Romantic', heading: 'Graceful' }
			],
			expectedSrcs: ['', '']
		},
		{
			question: "You settle into a bath, which looks like your 'moment of heaven'?",
			background: '#E8F3F5',
			theme: 'dark',
			required_answers_count: 2,
			answers: [
				{
					category: 'Bold',
					heading: 'Showtime',
					text: "Bathtime? It's showtime! Bring on the bubbles and blast the tunes, it's my private karaoke session."
				},
				{
					category: 'Classic',
					heading: 'Candlelit Retreat',
					text: 'A long relaxing soak to wash away the stresses of the day. I soak in style with a good book and a generous glass of wine!'
				},
				{
					category: 'Minimalist',
					heading: 'Rapid Refresh',
					text: "A bath? I'm all about efficiency! A quick shower while tuning into my favourite podcast is all I need."
				},
				{
					category: 'Calming',
					heading: 'Serene Sanctuary',
					text: "Guided meditation, Check! Soothing bath salts? Check! It's time to get my zen on. Wait, where's my rubber duck?"
				},
				{
					category: 'Romantic',
					heading: 'Romantic',
					text: 'I spend far too long soaking up my self-care routine. Leaving un-pampered from head to toe? Unthinkable!'
				}
			],
			expectedSrcs: ['', '']
		},
		{
			question: 'Which colour cards feel the most like you?',
			background: '#DED4CD',
			theme: 'dark',
			required_answers_count: 2,
			answers: [
				{
					category: 'Bold',
					heading: 'Bold'
				},
				{
					category: 'Classic',
					heading: 'Classic'
				},
				{
					category: 'Minimalist',
					heading: 'Understated'
				},
				{
					category: 'Calming',
					heading: 'Coastal'
				},
				{
					category: 'Romantic',
					heading: 'Romantic'
				}
			],
			expectedSrcs: ['', '']
		},
		{
			question: 'How does your bathroom look day-to-day?',
			background: '#E8F3F5',
			theme: 'dark',
			required_answers_count: 1,
			answers: [
				{
					category: 'Bold',
					heading: 'Organised Chaos',
					text: 'Every day is an adventure navigating the organised chaos. A lively mix of order and excitement!'
				},
				{
					category: 'Classic',
					heading: 'Neat & Orderly',
					text: "Timeless elegance defines my bathroom's day-to-day look. Neat and orderly with sophistication in every detail."
				},
				{
					category: 'Minimalist',
					heading: 'Clutter-free',
					text: "Clean and organised, always! Just the essentials, d&eacute;cor only makes an appearance if it's functional too."
				},
				{
					category: 'Calming',
					heading: 'Tranquil Haven',
					text: 'A serene sanctuary. I love creating a peaceful atmosphere that invites relaxation, a candle is always burning!'
				},
				{
					category: 'Romantic',
					heading: 'Insta Ready',
					text: 'Thoughtfully considered from every angle. Blooming with d&eacute;cor and florals, greeting you with a lovely fragrant embrace!'
				}
			],
			expectedSrcs: ['']
		}
	];
	window.questions = questions;

	let answersBefore = 0;
	let selectedBeforeQuestion = 1;
	let selectedBeforeAnswer = 1;

	questions.forEach((question, index) => {
	const section = document.getElementById('question-' + (index + 1));
    section.classList.add(question.theme + '-theme');

		let answersHtml = `
			<div class="option-container">
				<div class="uk-child-width-1-5 uk-grid-collapse uk-grid-match uk-margin-small-left uk-margin-small-right" uk-grid>
		`;

		question.answers.forEach((answer, answerIndex) => {
			answersHtml += `
				<div class="uk-padding-small">
					<label class="uk-flex uk-flex-column">
						<div class="animate option-shadow uk-position-relative suk-box-shadow-bottom uk-margin-auto-left uk-margin-auto-right uk-margin-remove-top uk-margin-remove-bottom"
						>
							<img src="/_/img/answers/${index + 1}/${answerIndex + 1}.png" alt="${answer.heading} answer illustration">
						</div>
						<h3 class="fancy-font uk-margin-medium-top uk-text-center uk-margin-small-bottom">${answer.heading}</h3>
						<p class="uk-text-center uk-margin-remove">${answer.text ?? ''}</p>
						<input class="option-checkbox" name="${section.id}" type="checkbox" value="${answer.category}" hidden />
					</label>
				</div>
			`;
		});

    answersHtml += `
        </div>
      </div>
    `;

    let selectedCurrentHtml = '';

    for(let i = 0; i < question.required_answers_count; i++) {
    	if (index == 1) {
    		var img = `/_/img/empty-2.svg`;
    	} else if (index == 3) {
    		var img = `/_/img/empty-4.svg`;
    	} else {
    		var img = `/_/img/empty-${question.theme}.svg`;
    	}
    	selectedCurrentHtml += `
				<div class="empty-placeholder-container uk-width-auto suk-width-1-${question.required_answers_count}">
					<img id="empty-${section.id}-${i}" src="` + img + `" alt="Empty answer placeholder" class="empty-placeholder uk-display-block">
				</div>
			`;
    }

	let selectedBeforeHtml = '';

	for(let i = 0; i < answersBefore; i++) {
		if(selectedBeforeAnswer > questions[selectedBeforeQuestion - 1].required_answers_count) {
			selectedBeforeQuestion++;
			selectedBeforeAnswer = 1;
		}

		selectedBeforeHtml += `
			<div>
				<img src="/_/img/empty-${question.theme}.png" alt="Empty answer placeholder" width="40" data-question="${selectedBeforeQuestion}" data-answer="${selectedBeforeAnswer}">
			</div>
		`;

		selectedBeforeAnswer++;
	}

	selectedBeforeQuestion = 1;
	selectedBeforeAnswer = 1;

	answersBefore += question.required_answers_count;

    section.innerHTML = `
    <div class="panel-container question-${index}">
    	<div class="logo-container">
				<div class="vado-logo uk-position-top-right">
					<a href="/"><img src="/_/img/vado-logo-${question.theme}.svg" alt="Vado" width="70"></a>
				</div>
				<div class="cameo-logo uk-position-top-left">
					<a href="/"><img src="/_/img/cameo-logo-${question.theme}.svg" alt="Cameo" width="170" height="32"></a>
				</div>
			</div>

			<h2 class="uk-margin-small-top uk-text-uppercase uk-text-center uk-margin-remove-bottom">${question.question}</h2>
			<p class="uk-text-center uk-margin-bottom uk-margin-remove-top">Please tap ${getIntName(question.required_answers_count)} to select</p>

			${answersHtml}

			<div class="progress-container">
				<div class="uk-grid-collapse" uk-grid>
					<div class="uk-width-2-5">
						<div class="js-selected-options-before uk-height-1-1 uk-grid-collapse uk-flex uk-flex-middle uk-padding-small" uk-grid>
							${selectedBeforeHtml}
						</div>
					</div>
					<div class="uk-width-1-5">
						<div class="js-selected-option-current uk-flex uk-flex-center uk-text-center uk-grid-collapse uk-margin-remove-top" uk-grid>
							${selectedCurrentHtml}
						</div>
					</div>
					<div class="uk-width-2-5">
						<div class="uk-flex uk-flex-middle uk-height-1-1 uk-padding-small">
							<button type="button" class="uk-button button-${question.theme} js-next uk-button-large" data-current="${index + 2}">Next</button>
						</div>
					</div>
				</div>

				<div class="progress js-progress ${question.theme}-theme">
					<h4 class="uk-width-2xlarge uk-margin-remove-bottom uk-margin-remove-top uk-text-left uk-margin-auto" style="padding-left: 30px;">Question ${index + 1} of ${questions.length}</h4>
					<div class="uk-child-width-1-5 uk-grid-small uk-width-2xlarge uk-grid uk-margin-auto uk-padding-small" uk-grid>
						<div ${index == 0 ? 'class="active"' : ''}><div></div></div>
						<div ${index == 1 ? 'class="active"' : ''}><div></div></div>
						<div ${index == 2 ? 'class="active"' : ''}><div></div></div>
						<div ${index == 3 ? 'class="active"' : ''}><div></div></div>
						<div ${index == 4 ? 'class="active"' : ''}><div></div></div>
					</div>
				</div>
			</div>
		</div>
    `;
	});

  function getIntName(integer) {
      return ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine'][integer];
  }
}
